module.exports = __webpack_public_path__ + "img/qrcode_download.9b1e8f54.png";